function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" {...props}><g fill="none" fillRule="evenodd" transform="translate(1 1)"><circle cx="20" cy="20" r="20" fill="#F6F7FB" stroke="#D7DBE9" /><path fill="#6A6D7B" fillRule="nonzero" d="M10.274 29.726a.685.685 0 0 0 .495.206.685.685 0 0 0 .496-.206L20 20.991l8.735 8.735a.685.685 0 0 0 .496.206.702.702 0 0 0 .496-1.197L20.99 20l8.735-8.735a.702.702 0 0 0-.991-.991L20 19.009l-8.735-8.735a.702.702 0 0 0-.991.991L19.009 20l-8.735 8.735a.702.702 0 0 0 0 .991z" /></g></svg>;
});